import { INITIAL, PENDING, COMPLETED, FAILED } from "engine/modules/constants"
import moment from "moment"
import {
  READ_NOTIFICATIONS,
  READ_NOTIFICATIONS_SUCCEEDED,
  READ_NOTIFICATIONS_FAILED,
  MARK_READ_ONE,
  MARK_READ_ONE_SUCCEEDED,
  MARK_READ_ONE_FAILED,
  MARK_READ_ALL,
  MARK_READ_ALL_SUCCEEDED,
  MARK_READ_ALL_FAILED,
  WS_NOTIFICATIONS_ADD_MSG,
} from "../actions/types"

export const INITIAL_STATE = {
  status: INITIAL,
  data: [],
}

const getNotificationLevel = level => {
  switch (level) {
    case `SUCCESS`:
      return `success`
    case `ERROR`:
      return `error`
    case `WARNING`:
      return `warning`
    case `INFO`:
      return `info`
    default:
      return `success`
  }
}

export default function notificationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // read notifications list
    case READ_NOTIFICATIONS:
      return {
        ...state,
        status: PENDING,
      }
    case READ_NOTIFICATIONS_SUCCEEDED: {
      const responseData = {}
      // eslint-disable-next-line array-callback-return
      action.response.map(item => {
        responseData[item.uuid] = {
          date: moment(item.createdDate).format(`LLL`),
          uuid: item.uuid,
          title: item.description,
          icon: getNotificationLevel(item.level),
          isRead: item.read,
          sortDate: item.createdDate,
        }
      })
      return {
        ...state,
        status: COMPLETED,
        data: responseData,
      }
    }
    case READ_NOTIFICATIONS_FAILED:
      return {
        ...state,
        status: FAILED,
        data: [],
      }

    // read mark one notification as read
    case MARK_READ_ONE:
      return {
        ...state,
        status: PENDING,
      }
    case MARK_READ_ONE_SUCCEEDED: {
      const uuid = action.response
      return {
        ...state,
        status: COMPLETED,
        data: { ...state.data, [uuid]: { ...state.data[uuid], isRead: true } },
      }
    }
    case MARK_READ_ONE_FAILED:
      return {
        ...state,
        status: FAILED,
      }

    // read mark all notifications as read
    case MARK_READ_ALL:
      return {
        ...state,
        status: PENDING,
      }
    case MARK_READ_ALL_SUCCEEDED: {
      const readData = {}
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const items in state.data) {
        readData[items] = { ...state.data[items], isRead: true }
      }
      return {
        ...state,
        status: COMPLETED,
        data: readData,
      }
    }
    case MARK_READ_ALL_FAILED:
      return {
        ...state,
        status: FAILED,
      }

    // ws notifications
    case WS_NOTIFICATIONS_ADD_MSG: {
      const { msg } = action
      const { data } = state
      const msgData = data
      msgData[msg.uuid] = {
        date: moment(msg.createdDate).format(`LLL`),
        uuid: msg.uuid,
        title: msg.description,
        icon: getNotificationLevel(msg.level),
        isRead: false,
        sortDate: msg.createdDate,
      }
      return {
        ...state,
        data: msgData,
        status: COMPLETED,
      }
    }
    default:
      return state
  }
}
